import { render, staticRenderFns } from "./ReportTen.vue?vue&type=template&id=64e73bd4"
import script from "./ReportTen.vue?vue&type=script&lang=js"
export * from "./ReportTen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports